import { Routes } from '@angular/router';

// Component Imports (Shell and 404 remain eager-loaded)
import { ShellComponent } from './components/shell/shell.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

export const routes: Routes = [
	{
		path: '',
		component: ShellComponent,
		children: [
			{
				path: 'home',
				loadComponent: () =>
					import('./pages/home-page/home-page.component').then(
						(m) => m.HomePageComponent
					),
			},
			{
				path: 'about',
				loadComponent: () =>
					import('./pages/about-page/about-page.component').then(
						(m) => m.AboutPageComponent
					),
			},
			{
				path: 'test',
				loadComponent: () =>
					import('./pages/test-page/test-page.component').then(
						(m) => m.TestPageComponent
					),
			},
			{ path: '', redirectTo: 'home', pathMatch: 'full' },
		],
	},
	{ path: '**', component: PageNotFoundComponent },
];
